import { DataBean } from "../DataBean";

export class ProductionResource extends DataBean{


    public async getProductionResourceCatalog(idProductionResource:any):Promise<any>
    {
        return this.getCustomService("QuickDataERPCore","java.util.List_getProductionResourceCatalog_Number",[idProductionResource]);
    }


    
    public async getProductionResourceConstants(id:number| null):Promise<any>
    {
        return this.getCustomService("QuickDataERPCore","java.util.List_getProductionResourceConstants_Number",[id]);
    }
}